import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { QueryExecution } from '../../types';
import {
  Column,
  ColumnKeys,
  DEFAULT_PAGE_SIZE,
  FILTERS,
  LiveSearchMetadataGridViewData,
  METADATA_FILTER_SENT_ROWS,
} from '../types';
import { ViewConfiguration, ViewType } from '../../../../grid/gridView/types';
import { ColumnDetails, ColumnType } from '../../../../grid/types/common';
import { MetadataStatus } from '../../../common/types';
import { Status } from '../../../../configurationProfilesApp/maintenanceWindowGrid/types';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';

export class LiveSearchMetadataGridViewDataProvider extends BaseWebComponentDataProvider {
  private stringsTranslator = BaseWebComponentTranslator.getInstance();

  public getDataForView(queryExecution: QueryExecution | null): LiveSearchMetadataGridViewData {
    const view: ViewConfiguration<any, any> = this.getView();
    return {
      views: [view],
      allColumns: this.getAllColumns(),
      defaultViewProps: view,
      queryExecution,
    };
  }

  private getView(): ViewConfiguration<any, any> {
    return {
      id: 'metadata-grid',
      name: this.dependencies.translateFn('Default view'),
      type: ViewType.DEFAULT,
      filters: FILTERS,
      displayedColumns: [
        Column.ENDPOINT,
        Column.QUERY_EXECUTION_TIME,
        Column.AVAILABLE_ROWS,
        Column.SENT_ROWS,
        Column.STATUS,
        Column.ERROR_MESSAGE,
      ],
      pageSize: DEFAULT_PAGE_SIZE,
      compactView: true,
    };
  }

  private getAllColumns(): Array<ColumnDetails<any, any>> {
    return [
      {
        filteringDisabled: true,
        column: Column.ENDPOINT,
        key: ColumnKeys.ENDPOINT,
        columnName: this.dependencies.translateFn('Endpoint'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        filteringDisabled: true,
        column: Column.QUERY_EXECUTION_TIME,
        key: ColumnKeys.QUERY_EXECUTION_TIME,
        columnName: this.dependencies.translateFn('Query execution time'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        filteringDisabled: true,
        column: Column.AVAILABLE_ROWS,
        key: ColumnKeys.AVAILABLE_ROWS,
        columnName: this.dependencies.translateFn('Available rows'),
        type: ColumnType.STRING,
        removable: false,
      },
      {
        column: Column.SENT_ROWS,
        key: ColumnKeys.SENT_ROWS,
        columnName: this.dependencies.translateFn('Sent rows'),
        type: ColumnType.ENUM,
        removable: false,
        values: this.getSentRowsValues(),
        flexGrow: 1,
      },
      {
        column: Column.STATUS,
        key: ColumnKeys.STATUS,
        columnName: this.dependencies.translateFn('Status'),
        type: ColumnType.ENUM,
        removable: false,
        values: this.getStatusValues(),
        flexGrow: 1,
      },
      {
        filteringDisabled: true,
        column: Column.ERROR_MESSAGE,
        key: ColumnKeys.ERROR_MESSAGE,
        columnName: this.dependencies.translateFn('Error message'),
        type: ColumnType.STRING,
        removable: false,
      },
    ];
  }

  private getSentRowsValues(): Array<{ label: string; value: METADATA_FILTER_SENT_ROWS }> {
    return [
      {
        label: this.dependencies.translateFn('No results'),
        value: METADATA_FILTER_SENT_ROWS.NO_SENT_ROWS_RECEIVED,
      },
      {
        label: this.dependencies.translateFn('Results available'),
        value: METADATA_FILTER_SENT_ROWS.SENT_ROWS_RECEIVED,
      },
    ];
  }

  private getStatusValues(): Array<{ label: string; value: MetadataStatus }> {
    return [
      {
        label: this.stringsTranslator.getTranslatedMetadataStatus(MetadataStatus.DISMISSED),
        value: MetadataStatus.DISMISSED,
      },
      {
        label: this.stringsTranslator.getTranslatedMetadataStatus(MetadataStatus.DELIVERED),
        value: MetadataStatus.DELIVERED,
      },
      {
        label: this.stringsTranslator.getTranslatedMetadataStatus(MetadataStatus.DELIVERED_WITH_ERROR),
        value: MetadataStatus.DELIVERED_WITH_ERROR,
      },
      {
        label: this.stringsTranslator.getTranslatedMetadataStatus(MetadataStatus.FAILED_SESSION_START),
        value: MetadataStatus.FAILED_SESSION_START,
      },
    ];
  }
}
